var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37158 13.4191C4.10153 14.8517 5.27079 16.0131 6.70828 16.7334C8.14578 17.4536 9.77604 17.6949 11.3605 17.4219C12.945 17.149 14.4006 16.3761 15.5142 15.2164C16.6279 14.0566 17.3411 12.5709 17.5496 10.9767C17.7581 9.38242 17.451 7.76328 16.673 6.35616C15.8951 4.94904 14.6873 3.82781 13.2263 3.15654C11.7653 2.48526 10.1278 2.29918 8.55342 2.62551C6.97904 2.95184 5.55043 3.77345 4.47661 4.97014",
    stroke: "url(#paint0_linear_978_4235)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_978_4235",
    x1: 22.7696,
    y1: -2.42482,
    x2: 1.8784,
    y2: 18.2223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.de8162bf60474de4dddd69a9248ae133.svg";
export { ForwardRef as ReactComponent };